"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MatchFactorInfoBox = exports.MFIBox = exports.InfoBox = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["title", "isBusiness", "children"];
var InfoLink = (0, _styledComponents["default"])(_baseReactComponents.Copy).attrs(function () {
  return {
    as: _baseReactComponents.Link,
    size: 'xs',
    bold: true,
    light: true
  };
}).withConfig({
  displayName: "InfoLink",
  componentId: "sc-1xvszy0-0"
})(["color:", ";cursor:pointer;:hover{color:", ";}"], _baseReactComponents.theme.neutral400, _baseReactComponents.theme.neutral400);
var Title = (0, _styledComponents["default"])(_baseReactComponents.Copy).attrs(function () {
  return {
    size: 'sm',
    bold: true,
    light: true
  };
}).withConfig({
  displayName: "Title",
  componentId: "sc-1xvszy0-1"
})([""]);
var Content = (0, _styledComponents["default"])(_baseReactComponents.Copy).attrs(function () {
  return {
    size: 'xs',
    light: true
  };
}).withConfig({
  displayName: "Content",
  componentId: "sc-1xvszy0-2"
})([""]);

var Dot = _styledComponents["default"].div.withConfig({
  displayName: "Dot",
  componentId: "sc-1xvszy0-3"
})(["width:8px;height:8px;background:", ";border-radius:50%;"], _baseReactComponents.theme.good);

var InfoBoxContainer = _styledComponents["default"].div.withConfig({
  displayName: "InfoBoxContainer",
  componentId: "sc-1xvszy0-4"
})(["display:grid;grid-template-columns:8px 1fr;grid-gap:8px;align-items:baseline;background-color:", ";border-radius:4px;padding:16px;color:", ";& > ", "{grid-column:1 / -1;}& > ", "{grid-column-start:2;justify-self:end;}"], _baseReactComponents.theme.neutral200, _baseReactComponents.theme.neutral400, Title, InfoLink);

var InfoBox = function InfoBox(_ref) {
  var title = _ref.title,
      children = _ref.children,
      _ref$linkText = _ref.linkText,
      linkText = _ref$linkText === void 0 ? 'Learn More' : _ref$linkText,
      linkHref = _ref.linkHref,
      linkTarget = _ref.linkTarget;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(InfoBoxContainer, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Title, {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Dot, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(Content, {
      children: children
    }), linkHref ? /*#__PURE__*/(0, _jsxRuntime.jsx)(InfoLink, {
      href: linkHref,
      target: linkTarget,
      children: linkText
    }) : null]
  });
};

exports.InfoBox = InfoBox;

var _default = (0, _styledComponents["default"])(InfoBox).withConfig({
  componentId: "sc-1xvszy0-5"
})([""]);

exports["default"] = _default;

var MFIBox = function MFIBox(_ref2) {
  var _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? "About Nav's MatchFactor" : _ref2$title,
      isBusiness = _ref2.isBusiness,
      children = _ref2.children,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(InfoBox, Object.assign({
    title: title,
    isBusiness: isBusiness
  }, props, {
    children: children || /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Text, {
        bold: true,
        light: true,
        children: "MatchFactor is"
      }), ' ', "Nav's estimation of how well this financing option matches your", isBusiness ? " current business needs" : " credit profile", "."]
    })
  }));
};

exports.MFIBox = MFIBox;
var MatchFactorInfoBox = (0, _styledComponents["default"])(MFIBox).withConfig({
  displayName: "MatchFactorInfoBox",
  componentId: "sc-1xvszy0-6"
})([""]);
exports.MatchFactorInfoBox = MatchFactorInfoBox;
//# sourceMappingURL=index.js.map